import React, { useState, useEffect } from 'react';
import { useGetDesignerPerformance } from '../../Hooks/index';
import { performanceInitialBody } from '../../Statics/index';
import MonthSlider from '../../../../Financial/Scheduler/Components/MountSlider/MonthSlider';
import { Box, Grid, Divider } from '@mui/material'
import { Form, Formik, useFormikContext } from "formik";
import AsynchronousAutocomplete from '../../../../../Components/AsyncAutoComplete/AsyncAutoComplete';
import AsyncCustomerSelect from '../../../../../Components/AsyncCustomerSelect/AsyncCustomerSelect';
import PrimaryButton from "../../../../../General/Components/PrimaryButton/PrimaryButton";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FormikControl from "../../../../../Components/Formik/FormikControl/FormikControl";
import DatePic from "../../../../PersonFroms/components/Forms/Leave/components/DatePic";
import DetailsDay from './Components/DetailsDay/DetailsDay';
import moment from 'jalali-moment';



const FunctionReports = ({ changeModuleMode }) => {
    const [mainBody, setMainBody] = useState(performanceInitialBody);
    const { data: DesignerPerformanceData, isFetching } = useGetDesignerPerformance(mainBody);
    const [orderSelected, setOrderSelected] = useState({})
    const [customerSelected, setCustomerSelected] = useState([]);
    const [designers, setDesigners] = useState([])





    const resetForm = () => {

    }

    const initialSubmitFilterForm = (data) => {
        setMainBody((prev) => ({ ...data }))
    }

    const initialResetFilterBody = () => {
        setMainBody({...performanceInitialBody })
    }








    return (
        <Grid container
            sx={{ heigth: '600px' }}
        >


            <Grid item xs={10} sx={{ ml: 5 }}  >
                <Box sx={{ width: "100%" }}>
                    <Formik
                        enableReinitialize
                        initialValues={mainBody}

                        onSubmit={(data) => {
                            initialSubmitFilterForm(data)
                        }}>
                        {({
                            values,
                            setFieldValue,
                            errors,
                            touched,
                            isValid,
                            dirty,
                            handleReset,
                        }) => (
                            <Form style={{ width: "100%" }}>
                                <Grid container sx={{ display: "flex", alignItems: "center", p: 1 }} >


                                    <Grid item xs={12} sm={2} >

                                        <Box sx={{ p: '8px' }}>
                                            <DatePic
                                                sx={{ m: 2 }}
                                                lable={"تاریخ"}
                                                setFormValues={setFieldValue}
                                                formValues={values}
                                                formik={true}
                                                name="date"
                                            />
                                        </Box>

                                    </Grid>




                                    <Grid item xs={12} sm={2.4} >
                                        <AsynchronousAutocomplete
                                            setFieldValue={setFieldValue}
                                            order={orderSelected}
                                            setMainOrderSelected={setOrderSelected}


                                        />
                                    </Grid>

                                    <Grid item xs={12} md={2.4}>
                                        <Box sx={{ p: '8px' }}   >
                                            <AsyncCustomerSelect
                                                formFieldKey='customerId'
                                                setFieldValue={setFieldValue}
                                                setMainCustomerSelected={setCustomerSelected}
                                                mainCustomerSelected={customerSelected}

                                            />
                                        </Box>
                                    </Grid>


                                    <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'start' }}>
                                        <Box sx={{ display: 'flex', gap: 2, px: 1 }}   >
                                            <PrimaryButton
                                                type={'submit'}
                                                // disabled={!value || value == 2 && selectedDate == null}
                                                sx={{ borderRadius: '8px', backgroundColor: "#1E6AFD", padding: '0.5rem 3rem' }}
                                                label={"اعمال"}
                                            />

                                            <PrimaryButton
                                                onClick={() => {
                                                    // handleReset();
                                                    initialResetFilterBody();

                                                }}
                                                // disabled={!values?.designerId || !values?.orderId}
                                                sx={{
                                                    background: (false)
                                                        ? "rgba(0,0,0,0.2)"     // حالت disabled
                                                        : "rgba(30, 106, 253, 1)",

                                                    color: (false) ? "#999" : "#fff",

                                                    borderRadius: "8px",
                                                    padding: "0.4rem 1rem",

                                                    "&:hover": {
                                                        background: (false)
                                                            ? "rgba(0,0,0,0.2)" // در disabled هوور نداشته باشد
                                                            : "rgba(30, 106, 253, 0.8)",
                                                    },
                                                }}
                                                endIcon={<RestartAltIcon />}
                                                label={"بازیابی"}
                                            />

                                        </Box>
                                    </Grid>






                                </Grid>
                            </Form>
                        )}
                    </Formik>

                </Box>

                <Grid item xs={12} >
                    <Box sx={{ width: '100%', py: 2 }}  >
                        <Divider />
                    </Box>
                </Grid>

            </Grid>






            <Grid item xs={12}  >
                <DetailsDay
                    mainData={DesignerPerformanceData}
                    isFetching={isFetching}
                    changeModuleMode={changeModuleMode}
                />
            </Grid>



        </Grid>
    )
}

export default FunctionReports